import React from "react";
import { Container } from "react-bootstrap";
import Navbar from "../general/Navbar.js";
import Styles from "./Header.module.css";

function Header(props) {
  return (
    <div
      className={Styles.EntireHeaderBox}
      style={props.style ? props.style : undefined}
    >
      <Container style={{ height: "100%" }}>
        <Navbar
          actionButtonText={props.actionButtonText}
          actionButtonIcon={props.actionButtonIcon}
          actionButtonRoute={props.actionButtonRoute}
        />
        <h1 className={Styles.Heading}>{props.label}</h1>
      </Container>
    </div>
  );
}

export default Header;
